import React from 'react';
import styled from 'styled-components';

import Card from 'antd/es/card';
import Typography from 'antd/es/typography';

import { formatDate } from 'helpers/date';

const { Text } = Typography;

const StyledCard = styled(Card)`
  background-color: #FFFFFF;
  border: none;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);

  & .ant-card-body {
    display: flex;
    flex-direction: column;
  }
`;

const StageName = styled(Text)`
  color: ${props => props.color};
  font-size: 12px;
  line-height: 20px;
  font-weight: normal;
`;

const Value = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: ${props => props.color};
`;

const STAGE_LABELS = {
  'Unload Started': {
    completed: 'Unload Started',
    estimated: 'Estimated Unload Start'
  },
  'Unload Finished': {
    completed: 'Unload Finished',
    estimated: 'Estimated Unload Finish'
  },
  'Undocked': {
    completed: 'Undocked',
    estimated: 'Estimated Undock'
  }
};

const getStageLabel = (stage, isEst) => {
  if (STAGE_LABELS[stage]) {
    return isEst ? STAGE_LABELS[stage].estimated : STAGE_LABELS[stage].completed;
  }
  return isEst ? `Estimated ${stage}` : stage;
};

const ProcessStageCard = ({ stage, color, value, processType = 'Inbound', ...rest }) => {
  let dt = null, valueColor, isEst = false;
  let stageLabel = stage;

  if (value) {
    if (value.dt) {
      dt = formatDate(value.dt * 1000, 'MMM dd, yyyy \'at\' HH:mm', { tzOffset: value.tzOffset });
      isEst = typeof value.isEst === 'boolean' ? value.isEst : isEst;
      valueColor = isEst ? '#A4B0BA' : '#232526';
      
      stageLabel = getStageLabel(stage, isEst);

      if (processType === 'Outbound') {
        stageLabel = stageLabel.replace('Unload', 'Load');
      }
      
    } else {
      dt = 'N/A';
      valueColor = '#A4B0BA';
    }
  }

  return (
    <StyledCard {...rest}>
      <StageName color={color}>{stageLabel}</StageName>
      {dt ? (
        <Value color={valueColor}>
          {dt}
        </Value>
      ) : ''}
    </StyledCard>
  );
};


export default ProcessStageCard;